import { httpClient } from '@/network/clientController'

/** Get amounts List
@docs Não há documentação
*/
export const requestAmountsList = payload => {
	return httpClient({
		method: 'GET',
		url: 'cardlesswithdrawal/emis/amounts',
		isCancellable: true
	})
}

/** Create Cardless Withdraw
@docs Não há documentação
*/
export const createCardlessWithdraw = payload => {
	return httpClient({
		method: 'POST',
		url: 'cardlesswithdrawal/emis',
        data: payload.data,
		operationTypeId: 19102 /* for mocks handling of tokens */
	})
}

/** Get Cardless withdraw list
@docs Não há documentação
*/
export const requestCardlessWidthdrawList = payload => {
	return httpClient({
		method: 'GET',
		url: `cardlesswithdrawal/emis/${payload.cardId}/list`,
		params: payload.params,
		isCancellable: true
	})
}

/** Get Cardless withdraw Code Detail
@docs Não há documentação
*/
export const requestCardlessWidthdrawCodeDetail = payload => {
	return httpClient({
		method: 'GET',
		url: `cardlesswithdrawal/emis/${payload.cardId}/${payload.codeId}`,
		isCancellable: true
	})
}

/** Cancel Cardless Withdraw Code
@docs Não há documentação
*/
export const cancelCardlessWithdrawCode = payload => {
	return httpClient({
		method: 'DELETE',
		url: `cardlesswithdrawal/emis/${payload.cardId}/${payload.codeId}`
	})
}
